import React from 'react'
import ExpandablePanel from '../controls/ExpandablePanel'
import KasKrsV12 from '../KasKrsV12'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import ChipInput from 'material-ui-chip-input'
import { controlHasError } from '../../lib/errorHandler'

class IdentyfikacjaPodmiotuKulturyV12 extends React.Component {
  handleAddChip = (chip) => {
    const { data, onSetSectionData } = this.props
    const newPKD = [...data.PKD, chip]
    onSetSectionData('PKD', newPKD)
  }

  handleDeleteChip = (chip, index) => {
    const { data, onSetSectionData } = this.props
    const newPKD = [...data.PKD]
    newPKD.splice(index, 1)
    onSetSectionData('PKD', newPKD)
  }

  render() {
    const { errors, data, onSetSectionData, onLoadGUS, onSetName } = this.props
    return (
      <ExpandablePanel title="IDENTYFIKACJA PODMIOTU">
        <form
          name="IdentyfikacjaPodmiotuKulturyV12"
          autoComplete="off"
          className="identyfikacjaPodmiotu"
        >
          <KasKrsV12
            className="kasKrs"
            hasError={(name) => controlHasError(errors, name)}
            data={{
              NrNIP: data.NrNIP || '',
              NrKRS: data.NrKRS || '',
            }}
            onSetSectionData={(e) => {
              onSetSectionData(e.target.name, e.target.value)
            }}
            onLoadGUS={onLoadGUS}
          />
          <FormControl component="fieldset" className="nazwa">
            <TextField
              error={controlHasError(errors, 'NazwaFirmy')}
              name="NazwaFirmy"
              label="Nazwa pełna"
              title={data.NazwaFirmy}
              value={data.NazwaFirmy}
              onChange={(e) => {
                onSetSectionData(e.target.name, e.target.value)
                onSetName(e.target.value)
              }}
            />
          </FormControl>
          <FormControl component="fieldset" className="pkd">
            <ChipInput
              error={controlHasError(errors, 'PKD')}
              InputLabelProps={{ shrink: true }}
              name="PKD"
              label="Kody PKD"
              placeholder="Wpisz kod + [ENTER]"
              value={data.PKD}
              onAdd={this.handleAddChip}
              onDelete={this.handleDeleteChip}
              helperText="Pojedynczy kod: 5 znaków, bez kropek"
            />
          </FormControl>
          <FormControlLabel
            className="checkboxLabel"
            control={
              <Checkbox
                name="InstytucjaKultury"
                color="primary"
                checked={this.props.data.InstytucjaKultury}
                onChange={(e) =>
                  this.props.onSetSectionData(e.target.name, e.target.checked)
                }
              />
            }
            label="wersja dla instytucji kultury"
          />
          <FormControlLabel
            className="checkboxLabel"
            control={
              <Checkbox
                name="CITEstonski"
                color="primary"
                checked={this.props.data.CITEstonski}
                onChange={(e) =>
                  this.props.onSetSectionData(e.target.name, e.target.checked)
                }
              />
            }
            label="wersja dla CIT estońskiego"
          />
        </form>
      </ExpandablePanel>
    )
  }
}

export default IdentyfikacjaPodmiotuKulturyV12
